import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { bool } from "prop-types";
import TimeframeChooser from "../TimeframeChooser";
import axios from "axios";
import { connect } from "react-redux";
import fileDownload from "js-file-download";
import { toastr } from "react-redux-toastr";

import config from "../../config";

class RefishingModal extends Component {
  constructor() {
    super();

    this.generate = this.generate.bind(this);
  }
  generate() {
    toastr.info("Gerando CSV...");
    const { video } = this.props;
    let url = `${config.trackingReportUrl}/refishing/${video.id}`;
    let start_date = this.props.timeframe.start;
    let end_date = this.props.timeframe.end;
    axios({
      method: "post",
      url: url,
      responseType: "blob",
      data: {
        start_date,
        end_date
      }
    }).then(res => {
      if (res.data.size === 0) {
        toastr.error("A busca não gerou nenhum resultado.");
        return;
      }
      toastr.success("CSV gerado com sucesso!");
      fileDownload(res.data, `Base_repescagem_${video.title}_${start_date}_${end_date}.csv`);
    });
  }
  render() {
    let { show } = this.props;
    return (
      <Modal show={show}>
        <Modal.Header>Repescagem</Modal.Header>
        <Modal.Body>
          <TimeframeChooser />
          <hr />
          <p>Start: {this.props.timeframe.start}</p>
          <p>End: {this.props.timeframe.end}</p>
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-link" onClick={this.props.close}>
            Cancelar
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              this.generate();
            }}
          >
            Gerar CSV
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

RefishingModal.propTypes = {
  show: bool
};

const mapStateToProps = state => {
  return {
    timeframe: state.timeframechooser.timeframe
  };
};

export default connect(mapStateToProps, null)(RefishingModal);



// WEBPACK FOOTER //
// ./src/components/modals/RefishingModal.js